import React from 'react'

import PresenterInfo from './PresenterInfo'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'

const TalkToAdvisor = props => {
  let documentContent = ''
  let imageSrc = ''

  documentContent = props.content

  imageSrc = props.backgroundImage

  return (
    <div className='u-sizeConstrained u-paddingVert8gu'>
      <div className='closing-content-wrapper' style={{ backgroundImage: `url(${imageSrc})` }}>
        <div className='closing-content-copy u-textCenter u-size7of12 u-pt-sizeFull u-marginCenter'>
          {props.content && (
            <>
              <div
                className='u-textColorWhite'
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(documentContent),
                }}></div>
            </>
          )}
        </div>
        <div className='u-size10of12 presenter-info-wrap u-marginCenter u-pt-sizeFull'>
          <PresenterInfo />
        </div>
      </div>
    </div>
  )
}

export default TalkToAdvisor
